import { dateFormat } from 'locale'
import { parse, format } from 'date-fns'

export const dateToText = (date) => format(date, dateFormat)

export const textToDate = (text) => parse(text, dateFormat, new Date())
